import type {
	BoardIssueMoveExecuteAction,
	BoardIssueMoveExecuteFailureAction,
	BoardIssueMoveExecuteSuccessAction,
} from '../../../actions/board-issue-move/index.tsx';
import type { State } from '../../../reducers/types.tsx';

export const boardIssueMoveShow = (eventPrefix: string) => () => ({
	name: `${eventPrefix}.board-issue-move.show`,
});

export const boardIssueMoveCancel = (eventPrefix: string) => () => ({
	name: `${eventPrefix}.board-issue-move.cancel`,
});

export const boardIssueMoveExecute =
	(eventPrefix: string) =>
	(preState: State, state: State, action: BoardIssueMoveExecuteAction) => ({
		name: `${eventPrefix}.board-issue-move.execute`,
		data: {
			transactionId: action.meta.optimistic.id,
		},
	});

export const boardIssueMoveExecuteSuccess =
	(eventPrefix: string) =>
	(preState: State, state: State, action: BoardIssueMoveExecuteSuccessAction) => ({
		name: `${eventPrefix}.board-issue-move.execute.success`,
		data: {
			transactionId: action.meta.optimistic.id,
		},
	});

export const boardIssueMoveExecuteFailure =
	(eventPrefix: string) =>
	(preState: State, state: State, action: BoardIssueMoveExecuteFailureAction) => ({
		name: `${eventPrefix}.board-issue-move.execute.failure`,
		data: {
			transactionId: action.meta.optimistic.id,
		},
	});
